export function downloadUTF8(filename, text) {
    const element = document.createElement("a");
    element.setAttribute(
        "href",
        `data:text/json;charset=utf-8,${encodeURIComponent(text)}`
    );
    element.setAttribute("download", filename);
    element.click();
}
